import { useLazyQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { GET_ORG_DETAILS } from "../../../../graphql/org-gql";
import { GET_POSITION_DETAIL } from "../../../../graphql/position-gql";
import { BusinessEntityType } from "../../../../types/address";
import { IOrg, IOrgResponse } from "../../../../types/org";
import { IPosition } from "../../../../types/position";
import OrgInfo from "../../../org/org-info";
import PositionDetailsInfo from "../../../position/position";

/**
 * Wrapper of Organization/Position.
 * Individual is not required here.
 */

interface BusinessEntityProps {
  entityId: number;
  entityType: BusinessEntityType;
  children?: React.ReactNode; // loading indicator
}

const BusinessEntity = (props: BusinessEntityProps) => {
  const { entityId, entityType, children } = props;

  const [getOrgDetail, { loading: loadingOrg }] = useLazyQuery<IOrgResponse>(GET_ORG_DETAILS);
  const [getPositionDetail, { loading: loadingPosition }] = useLazyQuery(GET_POSITION_DETAIL);

  const [organization, setOrganization] = useState<IOrg>();
  const [position, setPosition] = useState<IPosition>();

  useEffect(() => {
    setOrganization(undefined);
    setPosition(undefined);

    if (entityId <= 0) {
      return;
    } else if (entityType === 'organization') {
      getOrgDetail({
        variables: {
          id: entityId
        }
      }).then(response => setOrganization(response.data?.org));
    } else if (entityType === 'position') {
      getPositionDetail({
        variables: {
          positionId: entityId
        }
      }).then(response => setPosition(response.data?.position));
    }
  }, [entityId, entityType]);

  return (<>
    {(loadingOrg || loadingPosition) && children}
    {organization && <OrgInfo org={organization} onOrgSelect={() => { }} />}
    {position && <PositionDetailsInfo position={position} />}
  </>);
};

export default BusinessEntity;
